import { datadogRum } from '@datadog/browser-rum'

const STORAGE_KEY = 'dn_entry_door'

export const entryDoorFromPath = (path: string): string | null => {
  if (path === '/c' || path.startsWith('/c/')) return 'c'
  if (path.startsWith('/public-short-form')) return 'public-short-form'
  if (path.startsWith('/short-form')) return 'short-form'
  if (path.startsWith('/driver-application')) return 'driver-application'
  return null
}

export const recordEntryDoor = (door: string) => {
  let alreadySet = false
  try {
    alreadySet = !!window.sessionStorage.getItem(STORAGE_KEY)
    if (!alreadySet) window.sessionStorage.setItem(STORAGE_KEY, door)
  } catch {
    // sessionStorage unavailable (private mode, etc.) — tag best-effort below
  }
  if (!alreadySet) {
    datadogRum.setUserProperty('entryDoor', door)
  }
}
